<template>
	<div class="w-[50vw] h-[80vh] bg-white px-[40px] pt-[4%] box-border top-[50%] left-[50%] absolute"
		style="transform: translate(-50%,-50%);">
		<div class="text-[20px] font-bold text-[#1B2128] mb-[29px]">
			{{info.chapter_name}}
		</div>
		<div class="text-[20px] font-bold text-[#1B2128] mb-[30px]">
			{{langInfo.study_paper_result_title}}：
		</div>
		<div class="text-[34px] font-bold text-[#FF0000] mb-[10px]">
			{{info.score}}
		</div>
		<div class="" v-if="question_paper.type_part==1">
			<div class="mb-[30px]" v-for="(item,index) in score_json" :key="index">
				<div class="mb-[10px]">{{item.name}}</div>
				<label v-if="item.question_type=='single'">{{langInfo.study_paper_result_select}}</label>
				<label v-else-if="item.question_type=='case'">{{langInfo['Case Analysis Question']}}</label>
				: <label class="font-bold text-[#FF0000]">{{item.score}}</label>{{langInfo.study_paper_result_part}}
				({{langInfo.study_exam_total}}:
				{{item.total_score}} {{langInfo.study_paper_result_part}})
			</div>

	</div>
	<div class="" v-else>
		<div class="text-[#1B2128] text-[16px] mb-[29px]">
			{{langInfo.study_paper_result_total}} <label
				class="font-bold text-[#FF0000]">{{question_paper.total_score}}</label>
			！{{langInfo.study_paper_result_pass}}<label
				class="font-bold text-[#FF0000]">{{question_paper.passing_mark}}</label>{{langInfo.study_paper_result_part}}，<label
				v-if="info.result=='fail'">{{langInfo.study_paper_result_sorry}}<label
					class="font-bold text-[#FF0000]">{{langInfo.study_paper_result_fail}}</label>{{langInfo.study_paper_result_exam}}！</label>
			<label v-if="info.result=='pass'"><label
					class="font-bold text-[#68C340]">{{langInfo.study_paper_result_passed}}</label>{{langInfo.study_paper_result_exam}}！</label>
		</div>
		<div class="mb-[30px]">
			{{langInfo.study_paper_result_select}}: <label
				class="font-bold text-[#FF0000]">{{info.score}}</label>{{langInfo.study_paper_result_part}}
			({{langInfo.study_exam_total}}:
			{{question_paper.total_score}} {{langInfo.study_paper_result_part}})
		</div>

	</div>
	<div class="text-[12px] text-[#FF0000] leading-[25px] mb-[21px]">
		{{langInfo.study_paper_result_time}}：{{info.end_time}} <br />
		{{langInfo.study_paper_result_duration}}：{{info.TIME}}{{langInfo.study_paper_result_part}}
	</div>

	<div @click="goExamAnalysisClick()" v-if="isFinish"
		class="w-[200px] h-[40px] cursor-pointer leading-[40px] mx-auto rounded-[6px] text-center text-white text-[16px] bg-[#68C340]">
		{{langInfo.study_paper_result_answer}}
	</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id: '',
				info: {
					score: '',
					result: '',
					TIME: '',
					end_time: '',
				},
				question_paper: {
					total_score: '',
					passing_mark: '',
					type_part: 0
				},
				langInfo: {},
				order_item_id: '',

				isFinish: false,
				score_json: []
			}
		},
		mounted() {

			// 得分=score
			// 总分=question_paper.total_score
			// 及格分数=passing_mark
			// result 考试结果:pass=通过,fail=失败
			// TIME考试用时 分钟
			// end_time=结束时间
			this.id = this.$route.query.id
			this.order_item_id = this.$route.query.order_item_id
			this.getInfo()
			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}

		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			getInfo() {
				this.$api.get_question_exam({
					question_exam_id: this.id
				}).then((res) => {
					console.log(res);
					this.info = res.data
					this.isFinish = true
					document.title = this.info.chapter_name

					this.question_paper = res.data.question_paper

					this.score_json = res.data.score_json
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			goExamAnalysisClick() {
				let param = { order_item_id: this.order_item_id, id: this.info.question_paper_id, identification: this.info.identification }
				if (this.question_paper.type_part == 1) {
					this.$router.push({ path: '/exam/multipkeAnalysis', query: param })
				} else {
					this.$router.push({ path: '/exam/examAnalysis', query: param })
				}
			}

		}
	}
</script>

<style>
</style>